/**
 * Handles checkbox lists with show more/less functionality
 */

(function ($) {
	"use strict";
	$(document).ready(function () {
		let containerName = '.checkbox-list--show-more';
		let buttonName = '.checkbox-list__show-more-toggle';
		$(containerName).each(function () {
			let $container = $(this);
			let $button = $container.find(buttonName);
			$button.click(function (e) {
				e.preventDefault();
				$container.toggleClass('open');
				let currentText = $button.text();
				let swapText = $button.attr('data-attr-swap-text');
				$button.text(swapText);
				$button.attr('data-attr-swap-text', currentText);
				$button.attr('aria-expanded', $container.hasClass('open'));
			});
		});
	});
})(jQuery);
